const membershipBonusesSections = <NodeListOf<HTMLElement>>document.querySelectorAll(".membership-bonuses-section");

membershipBonusesSections.forEach((section) => {
    const activeFilters: Array<string> = [];

    const filterButtons = <NodeListOf<HTMLElement>>section.querySelectorAll(".filter-button");

    const partner = <NodeListOf<HTMLElement>>section.querySelectorAll(".partner__entry");

    filterButtons.forEach((button) => {
        button.addEventListener("click", () => {
            const active = button.classList.toggle("active");
            if (active) {
                activeFilters.push(button.dataset.filter);
            } else {
                activeFilters.splice(
                    activeFilters.findIndex((f) => f === button.dataset.filter),
                    1,
                );
            }

            if (activeFilters.length === 0) {
                partner.forEach((partner) => {
                    partner.classList.remove("hidden");
                });
            } else {
                partner.forEach((partner) => {
                    let isActive = false;
                    for (const f of activeFilters) {
                        isActive = partner.classList.contains(f);
                        if (isActive) {
                            break;
                        }
                    }
                    if (isActive) {
                        partner.classList.remove("hidden");
                    } else {
                        partner.classList.add("hidden");
                    }
                });
            }
        });
    });
});
